<template>
  <div>
    <div class="options">
      <slot></slot>
    </div>
    <v-select
      :options="options"
      label="label"
      v-model="selectEntity"
      @input="onChangeValue"
      @search:focus="onFocus"
      @search:blur="onBlur"
      :disabled="disabled"
    ></v-select>

    <input type="hidden" :name="name" :value="selectEntity !== null ? selectEntity.value : ''" />
    <input
      type="hidden"
      :name="name + '-label'"
      :value="selectEntity !== null ? selectEntity.label.trim() : ''"
    />
  </div>
</template>

<script>
export default {
  props: {
    name: {
      required: true
    },
    value: {
      required: false,
      default: ""
    },
    disabled: {
      required: false
    }
  },
  data: () => ({
    selectEntity: {
      label: "",
      value: ""
    },
    options: []
  }),
  watch: {
    value: function(newVal) {
      this.selectEntity = this.options.find(item => item.value == newVal);
      if (!this.selectEntity) {
        this.selectEntity = {
          label: "",
          value: ""
        }
      }
    }
  },
  methods: {
    generateOptions() {
      this.options = [];
      this.$el.querySelectorAll(".options option").forEach(option => {
        const item = {
          label: option.innerHTML.toUpperCase(),
          value: option.value
        };

        if (option.value == this.value) {
          this.selectEntity = item;
        }

        this.options.push(item);
      });

      this.options.sort((a, b) => {
        if (a.value.trim() == "") return -1;
        if (b.value.trim() == "") return 1;
        if (a.label.trim() < b.label.trim()) {
          return -1;
        }
        if (a.label.trim() > b.label.trim()) {
          return 1;
        }
        return 0;
      });

      const selectedItem = this.options.some(item => item.value == this.selectEntity.value);
      if (!selectedItem) {
        this.selectEntity = {
          label: "",
          value: ""
        }
      }
    },
    onChangeValue(ev) {
      this.$emit(
        "input", (this.selectEntity && this.selectEntity.value) || ""
      );

      this.$emit(
        "change",
        (this.selectEntity && this.selectEntity.value) || ""
      );
    },
    onFocus() {
      setTimeout(() => {
        const content = document.getElementById("content");
        if (content && content.scrollHeight > content.clientHeight) {
          content.style.height = content.scrollHeight + 20 + "px";
        }

        const contentsClasses = document.querySelectorAll(".content");
        contentsClasses.forEach(node => {
          if (node && node.scrollHeight > node.clientHeight) {
            node.style.height = node.scrollHeight + 20 + "px";
          }
        });
      }, 100);
    },
    onBlur() {
      const content = document.getElementById("content");
      content && content.removeAttribute("style");

      const contentsClasses = document.querySelectorAll(".content");
      contentsClasses.forEach(node => {
        node && node.removeAttribute("style");
      });
    }
  },
  mounted() {
    this.generateOptions();
  }
};
</script>
<style lang="scss" scoped>
.options {
  display: none;
}

/deep/ {
  ul {
    li,
    li:hover {
      display: list-item;
      width: auto;
      border: none;
      border-radius: 0;
      padding: 5px 10px;
      box-shadow: none;
    }

    li:hover {
      background-color: #6f7efb;
    }
  }

  button {
    background: transparent !important;
    border: none !important;

    &:active {
      background: transparent !important;
      border: none !important;
    }
  }

  input {
    text-transform: unset;
  }

  .vs__dropdown-option {
    white-space: normal;
  }

  .vs--searchable .vs__dropdown-toggle {
    background: #fff;
  }

  .vs__clear {
    display: none;
  }
}
</style>
